import MyInput from '@/components/UI/MyInput';
import MySelect from '@/components/UI/MySelect';

export default [
    MyInput,
    MySelect
]